import { JSONRPCClient } from 'src/apis/service';
import { EffectService } from 'src/apis/service/EffectService';
import { DecoFilterResponse, UserEffectSetting } from 'src/types/Deco';
import { client } from 'src/utils/api';

export const getDecoEffectListAPI = () => client.get<DecoFilterResponse>('/api/v1/deco/effects');

export const reportInMatchEffectUsageAPI = (
  matchId: string,
  userEffectSetting: UserEffectSetting
) => new EffectService(new JSONRPCClient()).reportInMatchEffectUsage(matchId, userEffectSetting);
